type ResolveRouteAfterPlanSelectionParams = {
  isPaidPlan: boolean;
  isKycVerified: boolean;
};

type ResolveRouteForActiveMembershipParams = {
  isKycVerified: boolean;
};

type ResolveRouteAfterSetupMembershipParams = {
  forceVerifyAfterPayment?: boolean;
  isKycVerified: boolean;
};

type ResolveEduKycUrlAfterMembershipSetupParams = {
  kycUrl?: string | null;
  eduKycUrl?: string | null;
  isKycVerified: boolean;
};

type ProfileMembershipRouteInput = {
  status?: string | null;
  planName?: string | null;
  billingType?: string | null;
  expiredAt?: string | null;
} | null;

const asNonEmptyString = (value?: string | null) =>
  typeof value === "string" && value.trim().length > 0 ? value.trim() : null;

export const resolveRouteAfterPlanSelection = ({
  isPaidPlan,
  isKycVerified,
}: ResolveRouteAfterPlanSelectionParams) => {
  if (isPaidPlan || isKycVerified) {
    return "/plan/membership-confirm" as const;
  }

  return "/kyc-verification" as const;
};

export const resolveRouteForActiveMembership = ({
  isKycVerified,
}: ResolveRouteForActiveMembershipParams) => {
  if (!isKycVerified) {
    return "/kyc-verification" as const;
  }

  return "/dashboard" as const;
};

export const resolveRouteAfterSetupMembership = ({
  forceVerifyAfterPayment = false,
  isKycVerified,
}: ResolveRouteAfterSetupMembershipParams) => {
  if (forceVerifyAfterPayment || !isKycVerified) {
    return "/kyc-verification" as const;
  }

  return "/dashboard" as const;
};

export const resolveRouteAfterSetupMembershipAlreadyCompleted = () =>
  "/kyc-verification" as const;

export const resolveRouteForProfileMembership = (
  membership: ProfileMembershipRouteInput
) => {
  const status = membership?.status?.toUpperCase() ?? "";
  const hasPlanName = Boolean(asNonEmptyString(membership?.planName));

  if (status === "NONE" || !hasPlanName) {
    return "/plan/membership" as const;
  }

  return null;
};

export const resolveEduKycUrlAfterMembershipSetup = ({
  kycUrl,
  eduKycUrl,
  isKycVerified,
}: ResolveEduKycUrlAfterMembershipSetupParams) => {
  if (isKycVerified) {
    return null;
  }

  return asNonEmptyString(kycUrl) ?? asNonEmptyString(eduKycUrl);
};
